import { render, staticRenderFns } from "./newsList.vue?vue&type=template&id=be640c78&scoped=true&"
import script from "./newsList.vue?vue&type=script&lang=ts&"
export * from "./newsList.vue?vue&type=script&lang=ts&"
import style0 from "./newsList.vue?vue&type=style&index=0&id=be640c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be640c78",
  null
  
)

export default component.exports